let Toggle = function (props) {
  let pressed = props.pressed === true;
  let disabled = props.disabled === true;
  let labels = props.labels || ["Off", "On"];
  let onPress = props.onPress;
  let background = pressed ? props.background : null;

  return (
    <button
      id={props.id}
      className="mc-toggle"
      role="button"
      aria-pressed={pressed}
      disabled={disabled}
      style={{ background }}
      onClick={onPress.bind(null, !pressed)}>
        <span/>
        {labels[pressed & 1]}
    </button>
  );
};

module.exports = Toggle;